var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import * as S from './style';
import { BlobInActiveIcon, BlobActiveIcon } from '../image-cdn-urls';
import Image from '../../../components/loggedout/common/Image';
export var BlobWithCircle = function (props) {
    useEffect(function () {
        if (props.blobData.displayAge == props.selectedAge) {
            props.setBlobActive && props.setBlobActive(true);
        }
    }, [props.blobData.displayAge]);
    return (_jsx(_Fragment, { children: _jsxs(S.BlobWrapper, __assign({ onClick: function () { return props.blobClickHandler(props.blobData.id, props.index); }, isPdsScreen: props.pdsScreen }, { children: [!props.pdsScreen && props.blobData.circleData && _jsx(S.CircleIcon, { id: "circle-".concat(props.blobData.id), top: props.blobData.circleData.top, left: props.blobData.circleData.left, diameter: props.blobData.circleData.diameter, circleColor: props.blobData.circleData.color }), _jsxs(S.IconTextWrapper, __assign({ isPdsScreen: props.pdsScreen, id: "blob-".concat(props.blobData.id) }, { children: [_jsx(S.BlobIcon, __assign({ rotateTimes: props.blobData.rotate, isPdsScreen: props.pdsScreen }, { children: _jsx(Image, { src: props.isBlobActive ? BlobActiveIcon : BlobInActiveIcon, alt: 'blob' }) })), _jsxs(S.AgeText, { children: [_jsx(S.AgeNumber, __assign({ smallText: props.pdsScreen }, { children: props.blobData.displayAge })), _jsx(S.Text, __assign({ smallText: props.pdsScreen }, { children: "years old" }))] })] }))] }), props.index) }));
};
export default BlobWithCircle;
